module.exports = __webpack_public_path__ + "static/institutionLogoCalifornia-e2789ce48e38d39f4432f32383c46d75.png";